import { useContext } from "react";
import AppContext from "./AppContext";

const useAppState = container => {
  const appContext = useContext(AppContext);
  if (!container) return AppContext;

  const containerInstance = appContext.get(container);
  if (containerInstance === undefined)
    console.error("container", container, "does not exist");
  return containerInstance;
};

export default useAppState;
